var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSalesmsgMark = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7469 19.2725C3.7469 19.2725 3.74692 19.2725 3.7469 19.2725L7.20294 14.819C7.55657 14.3633 8.20216 14.2582 8.68211 14.5782L10.7785 15.9758C11.9655 16.7671 13.58 16.2369 14.0668 14.896L16.3475 8.61363C16.3475 8.61363 16.5866 8.01043 16.0443 7.70006C15.502 7.38968 15.1081 7.90052 15.1081 7.90052L12.6162 11.7538C12.2831 12.2689 11.5928 12.412 11.0824 12.0717L8.92585 10.634C8.03778 10.042 6.85286 10.1727 6.11531 10.9442L1.6191 15.6473C1.21809 14.506 1 13.2784 1 12C1 5.92488 5.92488 1 12 1C18.0751 1 23 5.92488 23 12C23 18.0751 18.0751 23 12 23C10.4631 23 8.99988 22.6848 7.67135 22.1156L3.31537 22.9773C2.31727 23.1747 1.60911 22.0278 2.23281 21.2239L3.7469 19.2725Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSalesmsgMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SalesmsgMark.0e2f74caa53efba3ec5561c90828bd20.svg";